import { createStore } from 'satcheljs';
import { OptInFirstRunExperienceState } from './schema/OptInFirstRunExperienceState';

const store = createStore<OptInFirstRunExperienceState>('optInFirstRunExperienceState', {
    currentPage: 0,
    pageStartTime: new Date().getTime(),
    cumulativeTime: {},
    views: {},
})();

export default store;
